import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { getUsers, filterUsers } from '../../actions/adminActions';
import FilterForm from './filterForm';
import { getFilteredUsersCollection } from '../../selectors/userFilterSelector';

var panelStyle = { paddingLeft: '20px', paddingRight: '20px' }

class Users extends React.Component {

    constructor() {
        super();
    }

    componentDidMount() {
        // calling the new action creator
        this.props.localGetUsers();
    }

    render() {
        const { users } = this.props;

        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <h2 className="panel-title">Users</h2>
                        <FilterForm onChange={this.props.localFilterUsers}/>
                        <div className="panel">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Country</th>
                                        <th>Email</th>
                                        <th>Registred at</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead> 
                                <tbody>{typeof users === 'undefined' || users===null ? '' : (users.map((user, index) => (
                                    <tr key={user.id}>
                                        <td>{user.firstName} {user.lastName}</td>
                                        <td>{user.countryIso}</td>
                                        <td>{user.username}</td>
                                        <td>{dateFormat(user.created)}</td>
                                        <td className="text-right">
                                            <Link className="table-button" to={'/users/' + user.id}>
                                                View
                                            </Link>
                                        </td>
                                    </tr>
                                )))}</tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function dateFormat(date) {
    var played = new Date(date);

    var formated = new Intl.DateTimeFormat('default', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
    }).format(played)

    return formated;
}

function mapStateToProps(state) {
    return {
        users: getFilteredUsersCollection(state),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        //function
        localGetUsers: () => dispatch(getUsers()),
        localFilterUsers: (filter) => dispatch(filterUsers(filter)),
    };
}

const users = connect(mapStateToProps, mapDispatchToProps)(Users);
export { users as Users }; 